import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getSoftwareLevels } from "./Axios";

const SoftwareLevelSelect = props => {
  const [software_levels, setSoftwareLevels] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "software_level");
  };

  useEffect(() => {
    getSoftwareLevels((response) => {
      if (response && response.data) {
        const newSoftwareLevels = response.data.map((software_level) => ({
          value: software_level.id,
          label: software_level.name,
          uniqueIdentifier: software_level.unique_identifier,
        }));
        setSoftwareLevels(newSoftwareLevels);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-software-level-search"
      onChange={handleChange}
      options={software_levels}
      placeholder="Buscar y seleccionar manejo de software"
      value={
        software_levels.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default SoftwareLevelSelect;

